import React from "react";
import BasketProducts from "./basket_products";
import DownloadNotification from "./download_notification";
import { Button, Modal } from "react-bootstrap";
import classNames from "classnames";
import Download from "./basket/download";

const Basket = (props) => {
  const {
    open,
    products,
    onOpenClick,
    onCloseClick,
    onRemoveClick,
    onDownloadClick,
    onCloseDownloadNotificationClick,
    removingProductIds,
    downloading,
    disabledDownloadAll,
    disabledDropup,
    downloadPaths,
    availableDownloadOptions,
    translations
  } = props;
  const downloadsAvailable =
    availableDownloadOptions.all ||
    availableDownloadOptions.specs ||
    availableDownloadOptions.revit;

  if (!downloadsAvailable) {
    return null;
  }

  return (
    <div className="basket__app">
      <a
        href="#"
        className="basket__icon"
        onClick={open ? null : onOpenClick}
        title={translations.favourites_tooltip}
      >
        <i className="fa fa-star-o" />
        {products.length > 0 ? (
          <span className="badge basket__icon-badge">
            {products.length > 0 ? products.length : ""}
          </span>
        ) : null}
      </a>
      <Modal show={open} onHide={onCloseClick}>
        <Modal.Header closeButton>
          <Modal.Title>Selected products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {products.length == 0 ? (
            "There are no products in your basket"
          ) : (
            <BasketProducts
              products={products}
              onRemoveClick={onRemoveClick}
              removingProductIds={removingProductIds}
            />
          )}
          <DownloadNotification
            downloading={downloading}
            translations={translations}
            onCloseClick={onCloseDownloadNotificationClick}
          />
        </Modal.Body>
        <Modal.Footer>
          <Download
            disabledDownloadAll={disabledDownloadAll}
            disabledDropup={disabledDropup}
            onDownloadClick={onDownloadClick}
            downloadPaths={downloadPaths}
            availableDownloadOptions={availableDownloadOptions}
            productIds={products.map(p => p.id)}
            translations={translations}
          />
          <Button variant="outline-dark" onClick={onCloseClick}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Basket;